import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ResultValidation } from './form-elements.model';
import { isEmpty } from '../../core/services/simple-tools';

@Injectable({
  providedIn: 'root',
})
export class CustomValidatorService {
  patternValidation(isValidFormat: (date: string) => ResultValidation): ValidatorFn {
    const validator = (control: AbstractControl): ValidationErrors | null => {
      const errors: ValidationErrors = {};
      const validation = isValidFormat(control.value);

      if (!validation.result) {
        errors[validation.label] = true;
      }

      return Object.keys(errors).length === 0 ? null : errors;
    };

    return validator;
  }

  password(): ValidatorFn {
    const PASSWORD_PATTERN =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>_-])[A-Za-z\d!@#$%^&*(),.?":{}|<>_-]{8,16}$/;

    return this.patternValidation((value: string) => ({
      label: 'invalidPassword',
      result: PASSWORD_PATTERN.test(value),
    }));
  }

  required(): ValidatorFn {
    return this.patternValidation((value: string | undefined | null) => {
      const isValid = !isEmpty(value);

      return {
        label: 'required',
        result: isValid,
      };
    });
  }

  noBlankSpaces(): ValidatorFn {
    const validator = (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      const hasBlankSpaces = /\s/.test(value);

      return hasBlankSpaces ? { noBlankSpaces: true } : null;
    };

    return validator;
  }

  noLeadingBlankSpaces(minLength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      const startsWithBlankSpace = /^\s/.test(value);

      const isValidLength = value ? value.length >= minLength : true;

      if (startsWithBlankSpace || !isValidLength || isEmpty(value)) {
        return { noLeadingBlankSpacesMinLength: { requiredLength: minLength } };
      }

      return null;
    };
  }

  isEmail(): ValidatorFn {
    return this.patternValidation((value: string) => ({
      label: 'cxInvalidEmail',
      result: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i.test(value),
    }));
  }
}
